
import axios from '../config/axios';

export const url = '/api/contactokdnr3'


export const createcontactokdnr3 = ({
  token,
	nombrejivad,
	correoirnp8,
	telfono8f0j3g,
	mensajef5ig2,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombrejivad && correoirnp8 && telfono8f0j3g && mensajef5ig2 ) {

    axios.post(`${url}//create/basic/6897a3bdd9a58bc9adfc2e48`, {
		nombrejivad,
		correoirnp8,
		telfono8f0j3g,
		mensajef5ig2,

    }, {
      headers: {
        
        Authorization: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombrejivad) {
		reject({
			status: 'error',
			info: 'nombrejivad no esta definido',
		});
	}  else if (!correoirnp8) {
		reject({
			status: 'error',
			info: 'correoirnp8 no esta definido',
		});
	}  else if (!telfono8f0j3g) {
		reject({
			status: 'error',
			info: 'telfono8f0j3g no esta definido',
		});
	}  else if (!mensajef5ig2) {
		reject({
			status: 'error',
			info: 'mensajef5ig2 no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

